import { render, staticRenderFns } from "./BoardListView.vue?vue&type=template&id=0e7b6b1c&"
import script from "./BoardListView.vue?vue&type=script&lang=js&"
export * from "./BoardListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports